import {Task} from "@megaphonenpm/mputils/src/Task.js";

export class LoadDeploymentCSSTask extends Task {
  constructor () {
    super();
    this.name = 'LOAD_DEPLOYMENT_CSS';
  }

  start () {
    super.start();
    // TODO: Dynamically inject deployment-level screen-theme style overrides from deployment settings
    this.done();
  }
}